import React from 'react'

import LoadingPage from './LoadingPage'
import useConfirmationActions from './useConfirmationActions'

const QuickCheckoutHandler: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { goToMyRecording } = useConfirmationActions()

  if (goToMyRecording) {
    window.location.href = goToMyRecording
  }

  return <LoadingPage />
}

export default QuickCheckoutHandler
